type OtpChallenge = {
  authenticated: false;
  challengeId: string;
  channel: "email" | "whatsapp";
  expiresInSeconds: number;
};
async function post<T>(path: string, body: object): Promise<T> {
  const response = await fetch(`/api/auth-central/${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
    cache: "no-store",
  });
  if (!response.ok)
    throw new Error(
      "Não foi possível concluir a autenticação. Tente novamente.",
    );
  return response.status === 204
    ? (undefined as T)
    : ((await response.json()) as T);
}
export function requestRedesignOtp(input: {
  email?: string;
  phoneNumber?: string;
  preferredChannel: "email" | "whatsapp";
}) {
  return post<OtpChallenge | { authenticated: true }>("request-otp", {
    ...input,
    experience: "redesign",
  });
}
export function verifyRedesignOtp(input: {
  challengeId: string;
  code: string;
}) {
  return post<{ authenticated: true }>("verify-otp", {
    ...input,
    experience: "redesign",
  });
}
export function logoutCentralSession() {
  return post<void>("logout", {});
}
export function bootstrapRedesignSession() {
  return post<{ authenticated: true }>("bootstrap-redesign", {});
}
